// extracted by mini-css-extract-plugin
export default {"user-report-container":"RetailerReports_user-report-container__Y+hsV"};